module.exports = __webpack_public_path__ + "img/grad.6073382c.svg";